import VChart from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';

use([PieChart, CanvasRenderer]);

export default {
  name: 'componentsPie',

  props: {
    chartData: {
      type: Object,
    },
    flag: {
      type: Boolean,
    },
    legend: {
      type: Boolean,

    }
  },
  watch: {
    flag() {
      this.dateinit();
      let dataIndex = -1;
      const { pie } = this.$refs;
      if (!pie) {
        return;
      }
      const dataLen = pie.option.series[0].data.length;
      pie.dispatchAction({
        type: 'downplay',
        seriesIndex: 0,
        dataIndex,
      });
      dataIndex = (dataIndex + 1) % dataLen;
      this.dataIndex = dataIndex;
      pie.dispatchAction({
        type: 'highlight',
        seriesIndex: 0,
        dataIndex,
      });
      // this.timerfn();
    },
  },

  components: {
    VChart,
  },

  data() {
    return {
      option: {},
    };
  },

  created() {
    this.dateinit();
  },

  mounted() {
    this.startActions();
  },

  methods: {
    dateinit() {
      const { chartData } = this;
      const {
        title, unit, data, color, radius,
      } = chartData;
      this.option = {
        color: color || ['#5c17e5', '#33a7ff', '#007373', '#009926', '#e65117', '#ffbf00', '#9bbf30'],
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        },
        title: {
          text: title,
          top: 'center',
          left: 'center',
          textStyle: {
            color: '#fff',
            fontSize: 14,
            fontFamily: 'Microsoft YaHei UI',
          },
        },
        series: [
          {
            data,
            name: '',
            type: 'pie',
            radius: radius || ['30%', '80%'],
            label: {
              show: false,
              rich: {
                arial: {
                  fontFamily: 'Arial',
                },
                f14: {
                  fontSize: 12,
                },
              },
              color: '#fff',
              fontSize: 10,
              position: 'inner',
              formatter(params) {
                const { name, value } = params;
                return `{arial|${name}}\n {f14|${value}}${unit}`;
              },
              textShadowBlur: 1.5,
              textShadowColor: '#000',
            },
            emphasis: {
              label: {
                show: true,
                shadowBlur: 1.5,
              },
            },
          },
        ],
      };
      if (this.legend) {
        this.option.legend = {
          orient: 'vertical',
          top: "center",
          left: '5%',
          itemHeight: 11,
          itemWidth: 11,
          textStyle: {
            fontSize: 12,//字体大小
            color: '#ffffff'//字体颜色
          },
        }
      }
    },
    startActions() {
      let dataIndex = -1;
      const { pie } = this.$refs;
      if (!pie) {
        return;
      }
      const dataLen = pie.option.series[0].data.length;
      this.actionTimer = setInterval(() => {
        pie.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex,
        });
        dataIndex = (dataIndex + 1) % dataLen;
        this.dataIndex = dataIndex;
        pie.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex,
        });
      }, 3000);
    },

    stopActions() {
      clearInterval(this.actionTimer);
    },
  },
};
